export const ON_BASE_ONLINE_MY_DOCS_LOGIN_URL = "https://amazon.onbaseonline.com/MyDocs/login";
export const CONTACT_US_LINK = `https://${window.location.hostname}/contact-us`;
export const PHILIPPINES_WORK_AUTHORIZATION_GUIDE_URL =
  "https://glspub.s3-us-west-2.amazonaws.com/Work%20Authorization/Philippines%20Employee%20Guide/index.html#/";
export const IRELAND_EMPLOYEE_GUIDE_URL =
  "https://walpub.s3.us-west-2.amazonaws.com/EmployeeGuides/EMEA-MENA/Ireland/index.html#/";
export const SOUTH_AFRICA_EMPLOYEE_GUIDE_PDF_URL =
  "https://inside.hr.amazon.dev/content/dam/inside/za/employment/getting-hr-help/Employee-Guide-SouthAfrica-EN.pdf";
export const INDIA_WORK_EMPLOYEE_GUIDE_URL =
  "https://walpub.s3.us-west-2.amazonaws.com/EmployeeGuides/APAC/Employee_Guide_India.pdf";
export const INDIA_WORK_AUTHORIZATION_DOC_URL =
  "https://inside.hr.amazon.dev/in/en/employment/getting-hr-help-global/global-work-authorization/work-authorization.html";
